import React from 'react';

import { Collapse, ConfigProvider, Typography } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

const collapseTheme = {
  components: {
    Collapse: {
      headerBg: 'var(--uizz-antd-color-fill-tertiary)'
    }
  }
};

export type ActionCollapseProps = {
  title: string;
  icon?: React.ReactNode;
  defaultOpen?: boolean;
  disabled?: boolean;
  onExpand?: (expanded: boolean) => void;
  children?: React.ReactNode;
};

const ActionCollapse = ({ title, icon, defaultOpen, disabled, onExpand, children }: ActionCollapseProps) => (
  <ConfigProvider theme={collapseTheme}>
    <Collapse
      collapsible={disabled ? 'disabled' : undefined}
      defaultActiveKey={defaultOpen ? [title] : []}
      onChange={keys => onExpand?.(keys.includes(title))}
      expandIcon={({ isActive }) => (
        <Icon.ChevronDown size={16} className={`transition-transform ${isActive ? 'rotate-180' : ''}`} />
      )}
      className='w-full border border-(--uizz-antd-color-border-secondary)'
      items={[
        {
          key: title,
          label: (
            <div className='flex items-center gap-2'>
              {icon}
              <Typography.Text ellipsis>{title}</Typography.Text>
            </div>
          ),
          children
        }
      ]}
    />
  </ConfigProvider>
);

export default ActionCollapse;
